import type { ReactNode } from 'react';
import { Link } from 'react-router';
import {
  Button,
  buttonStyles,
  type ButtonStyleOptions,
} from '@skupreme/shared/ui';

type LinkButtonProps = ButtonStyleOptions & {
  to: string;
  disabled?: boolean;
  onClick?: () => void;
  children: ReactNode;
};

/*
 * A link drawn as a button. Disabled, it is a real disabled button instead:
 * a disabled button inside a link never let the click through to navigate.
 */
export function LinkButton({
  to,
  disabled,
  onClick,
  children,
  ...style
}: LinkButtonProps) {
  if (disabled) {
    return (
      <Button {...style} isDisabled>
        {children}
      </Button>
    );
  }

  return (
    <Link to={to} onClick={onClick} className={buttonStyles(style)}>
      {children}
    </Link>
  );
}
